import { eventChannel, END } from 'redux-saga'
import { version } from '../package'

export default (apiKey) => {
  const protocol = window.location.protocol.startsWith('https') ? 'wss' : 'ws'
  const ws = new WebSocket(`${protocol}://${window.location.host}/ws?apiKey=${apiKey}`)

  return {
    channel: eventChannel(emitter => {
      ws.onopen = () => {
        emitter({event: 'open'})
      }
      ws.onmessage = event => {
        emitter({event: 'message', payload: JSON.parse(event.data)})
      }
      ws.onerror = () => {
        console.error('WS: Websocket error')
      }
      ws.onclose = event => {
        console.log('WS: Websocket closed', event.code)
        emitter(END)
      }
      return () => {
        ws.close()
      }
    }),
    write: (method, payload) => {
      if (ws.readyState !== 1) {
        console.error('Websocket is not ready to communicate.')
        return
      }
      ws.send(JSON.stringify({ method, version, payload }))
    }
  }
}
